export default interface EstadoModel {
  nome: string;
  sigla: string;
}

export const ESTADO_UNDEFINED: EstadoModel = {
  nome: "",
  sigla: "",
};

export const ACRE: EstadoModel = { nome: "Acre", sigla: "AC" };
export const ALAGOAS: EstadoModel = { nome: "Alagoas", sigla: "AL" };
export const AMAPA: EstadoModel = { nome: "Amapá", sigla: "AP" };
export const AMAZONAS: EstadoModel = { nome: "Amazonas", sigla: "AM" };
export const BAHIA: EstadoModel = { nome: "Bahia", sigla: "BA" };
export const CEARA: EstadoModel = { nome: "Ceará", sigla: "CE" };
export const DISTRITO_FEDERAL: EstadoModel = {
  nome: "Distrito Federal",
  sigla: "DF",
};
export const ESPIRITO_SANTO: EstadoModel = {
  nome: "Espírito Santo",
  sigla: "ES",
};
export const GOIAS: EstadoModel = { nome: "Goiás", sigla: "GO" };
export const MARANHAO: EstadoModel = { nome: "Maranhão", sigla: "MA" };
export const MATO_GROSSO: EstadoModel = { nome: "Mato Grosso", sigla: "MT" };
export const MATO_GROSSO_DO_SUL: EstadoModel = {
  nome: "Mato Grosso do Sul",
  sigla: "MS",
};
export const MINAS_GERAIS: EstadoModel = { nome: "Minas Gerais", sigla: "MG" };
export const PARA: EstadoModel = { nome: "Pará", sigla: "PA" };
export const PARAIBA: EstadoModel = { nome: "Paraíba", sigla: "PB" };
export const PARANA: EstadoModel = { nome: "Paraná", sigla: "PR" };
export const PERNAMBUCO: EstadoModel = { nome: "Pernambuco", sigla: "PE" };
export const PIAUI: EstadoModel = { nome: "Piauí", sigla: "PI" };
export const RIO_DE_JANEIRO: EstadoModel = {
  nome: "Rio de Janeiro",
  sigla: "RJ",
};
export const RIO_GRANDE_DO_NORTE: EstadoModel = {
  nome: "Rio Grande do Norte",
  sigla: "RN",
};
export const RIO_GRANDE_DO_SUL: EstadoModel = {
  nome: "Rio Grande do Sul",
  sigla: "RS",
};
export const RONDONIA: EstadoModel = { nome: "Rondônia", sigla: "RO" };
export const RORAIMA: EstadoModel = { nome: "Roraima", sigla: "RR" };
export const SANTA_CATARINA: EstadoModel = {
  nome: "Santa Catarina",
  sigla: "SC",
};
export const SAO_PAULO: EstadoModel = { nome: "São Paulo", sigla: "SP" };
export const SERGIPE: EstadoModel = { nome: "Sergipe", sigla: "SE" };
export const TOCANTINS: EstadoModel = { nome: "Tocantins", sigla: "TO" };

export const estadosList: EstadoModel[] = [
  ACRE,
  ALAGOAS,
  AMAPA,
  AMAZONAS,
  BAHIA,
  CEARA,
  DISTRITO_FEDERAL,
  ESPIRITO_SANTO,
  GOIAS,
  MARANHAO,
  MATO_GROSSO,
  MATO_GROSSO_DO_SUL,
  MINAS_GERAIS,
  PARA,
  PARAIBA,
  PARANA,
  PERNAMBUCO,
  PIAUI,
  RIO_DE_JANEIRO,
  RIO_GRANDE_DO_NORTE,
  RIO_GRANDE_DO_SUL,
  RONDONIA,
  RORAIMA,
  SANTA_CATARINA,
  SAO_PAULO,
  SERGIPE,
  TOCANTINS,
];
